import { capitalizeFirstLetter } from '../util/string'

// placeCreate's refusals (CVL-163, Mutations::PlaceCreate) are whole sentences: no field name in front.
export const SAME_PLACE_MESSAGE =
  "Is this the same place? A place with this name is already in the directory in this town or nearby. Use it, or say it's a different place."
export const REPEAT_PLACE_MESSAGE = 'You already added this place.'

const translations = {
  password: {
    wrong: 'Wrong credentials. Please try again.',
  },
  name: {
    [SAME_PLACE_MESSAGE]: SAME_PLACE_MESSAGE,
    [REPEAT_PLACE_MESSAGE]: REPEAT_PLACE_MESSAGE,
  },
}

type ErrorType = { attribute: string; message: string }
// TODO: log to Rollbar when keys are missing
export const errorFromGraphqlResponseErrors = (error: ErrorType): string =>
  (translations[error.attribute] || error.attribute)[error.message] || `${capitalizeFirstLetter(error.attribute)} ${error.message}`

export const errorsFromGraphqlResponseErrors = (errors: ErrorType[]): string[] => (errors || []).map(errorFromGraphqlResponseErrors)

export const fullMessageErrors = (errors: ErrorType[]): string => errorsFromGraphqlResponseErrors(errors).join('\n')
